import React from "react";
import './landingPage.css'

export default (props) => (
  <div className="contentWrapper">
    {props.children}
  </div>
);
